<template>
  <div>
    <a-scene
      id="scene"
      vr-mode-ui="enabled: false"
    >
      <a-sky
        id="sky"
        :src="getFirstPracticeIntroPosterMin()"
        :data-src="getFirstPracticeIntroPoster()"
      />
    </a-scene>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import aframe from 'aframe'
import Const from '@/helpers/const'

let json = require('../../json/pratica-' + Const.PRACTICE_NUMBER + '.json')
export default {
  data () {
    return {
      dialog: 'true',
      json: json
    }
  },

  mounted () {
    this.$bus.$on('aframe-hide', function () {
      const scene = document.getElementById('scene')
      scene.style.visibility = 'hidden'
    })

    this.$bus.$on('aframe-show', function () {
      const scene = document.getElementById('scene')
      scene.style.visibility = 'visible'
    })

    // Lazy-load large poster image after 1000 ms page has loaded
    window.addEventListener('load', function () {
      setTimeout(function () {
        const skyImage = document.getElementById('sky')
        if (skyImage.getAttribute('data-src')) {
          skyImage.setAttribute('src', skyImage.getAttribute('data-src'))
        }
      }, 1000)
    }, false)
  },

  methods: {
    getFirstPracticeIntroPoster () {
      const pratica = this.json.pratica[0]
      return 'img/' + pratica.introducao.poster
    },

    getFirstPracticeIntroPosterMin () {
      const pratica = this.json.pratica[0]
      const poster = 'img/' + pratica.introducao.poster

      if (poster != null && poster !== '') {
        let tmp = poster.split('.')
        const posterMin = tmp.join('-min.')
        return posterMin
      }
      console.error('implementation error')
      return null
    }
  }
}
</script>
